import angular from 'angular';

angular
  .module('cxTaskflow')
  .controller('TaskScheduleChangeAssignmentDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'schedule',
    'invoiceStreamId',
    taskScheduleChangeAssignmentDialogCtrl,
  ]);

function taskScheduleChangeAssignmentDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  schedule,
  invoiceStreamId,
) {
  var vm = this;
  vm.updateRegistrations = true;
  vm.saving = false;

  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;

    var taskModel = {
      id: schedule.id,
      invoiceStreamId,
    };

    $http.put(appUrls.tasks + '/api/TaskSchedules/ChangeAssignment', taskModel).then(
      ({ data }) => {
        const newSchedule = data;
        if (!vm.updateRegistrations) {
          $element.modal('hide');
          close(newSchedule, 500);
          vm.saving = false;
          return;
        }
        //Update registrations
        var regModel = {
          taskTemplateId: schedule.taskTemplateId,
          oldInvoiceStreamId: schedule.invoiceStreamId,
          newInvoiceStreamId: invoiceStreamId,
        };
        $http.put(appUrls.api + '/api/Registration/ChangeAssignment', regModel).then(
          function({ data }) {
            $element.modal('hide');
            close(newSchedule, 500);
            vm.saving = false;
          },
          function(error) {
            flySvc.error(error);
            vm.saving = false;
          },
        );
      },
      function(error) {
        flySvc.error(error);
        vm.saving = false;
      },
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
